import { useState, useEffect } from 'react';
import { useToasts } from 'react-toast-notifications';
import language from '../../config/es';
import { isAllowed } from './crudHelpers';

// Estado mutable del formulario con sus utilidades comunes
export const useCrudState = (initialState) => {
  const { addToast } = useToasts();
  const [data, setData] = useState(initialState);

  const refreshState = () => {
    setData({
      ...data,
    });
  };
  const updateState = (value, id) => {
    setData({
      ...data,
      [id]: value,
    });
  };
  const viewNotification = (msm, action) => {
    addToast(msm, {
      appearance: action,
      autoDismiss: true,
    });
  };
  const handleSelectRow = (state) => {
    updateState(state.selectedRows, 'selectedRows');
  };
  const initStateDelete = (value) => {
    data.enable = value;
    data.showDelete = value;
    data.pendingData = !value;
    refreshState();
  };
  // Valida y bloquea el formulario mientras se verifica el permiso
  const prepareSave = (validate) => {
    data.enable = false;
    validate();
    data.enable = data.errors.length > 0;
    refreshState();
  };
  // Recarga los datos notificando al usuario
  const reloadWith = async (loader) => {
    data.enable = false;
    await loader();
    viewNotification(language.messages.success_reload_data, 'success');
    data.enable = true;
    refreshState();
  };
  // Resultado de la baja de registros
  const finishDelete = (ok, errorMessage, reload) => {
    if (ok) {
      viewNotification(language.messages.msmDisableAll, 'success');
      initStateDelete(true);
      reload();
    } else {
      viewNotification(errorMessage, 'error');
      initStateDelete(true);
    }
  };

  return {
    data,
    setData,
    refreshState,
    updateState,
    viewNotification,
    handleSelectRow,
    initStateDelete,
    reloadWith,
    finishDelete,
    prepareSave,
  };
};

// Carga inicial y refresco de la sesion en cada cambio de estado
export const useCrudLifecycle = (ref, data, onInit) => {
  useEffect(() => {
    onInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    ref.current.onRefreshCurrentSession();
  }, [ref, data]);
};

// Verificacion de permisos al iniciar y para cada accion posterior
export const usePermissionGate = ({
  ref,
  data,
  dispatch,
  getPermissions,
  notify,
  onAllowed,
}) => {
  const [loadInit, setLoadInit] = useState(true);
  const [msgRestricted, setMsgRestricted] = useState('');

  const requestPermission = (action) =>
    dispatch(getPermissions(data.auth.id.user.username, action));

  const initPermissions = async () => {
    const res = await requestPermission(data.action.list);
    if (isAllowed(res)) {
      setLoadInit(false);
      onAllowed();
    } else {
      setMsgRestricted(res.response.data.error);
    }
  };
  useCrudLifecycle(ref, data, initPermissions);

  // Ejecuta la accion si hay permiso; caso contrario advierte
  const withPermission = async (action, onGranted, onDenied) => {
    const res = await requestPermission(action);
    if (isAllowed(res)) {
      await onGranted();
    } else {
      if (onDenied) onDenied();
      notify(res.response.data.error, 'warning');
    }
  };

  return { loadInit, msgRestricted, withPermission };
};
